import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useResponseFormHandler } from 'src/utils/hooks/useResponseFormHandler';
import { useFetch } from 'src/utils/hooks/useFetch';
import { NewContactForm } from './NewContactForm';
import { GuestApi } from 'src/api/base/Guest';
import { ICreateGuestModel, IGuestInfo } from 'src/api/base/Guest/types';
import { setGuest } from 'src/store/createGuest/slice';
import { RootState } from 'src/store';

type PNewContactFormContainer = {
  onSuccess: (guest: ICreateGuestModel) => void;
  guest?: IGuestInfo | null;
};

export const NewContactFormCreate: React.FC<PNewContactFormContainer> = (
  props,
) => {
  const { onSuccess } = props;
  const dispatch = useDispatch();
  const storedGuest = useSelector(
    (state: RootState) => state.createGuest.guest,
  );

  return (
    <NewContactForm
      onSubmit={(data) => {
        // set guest data to redux
        dispatch(setGuest(data));
        onSuccess(data);
        // doFetch(data);
      }}
      errors={{}}
      loading={false}
      guest={storedGuest}
      submitBtnText="Next"
      isCreatingForm
    />
  );
};

export const NewContactFormUpdate: React.FC<PNewContactFormContainer> = (
  props,
) => {
  const { onSuccess, guest } = props;
  const [{ response, isLoading, error }, doFetch] = useFetch<any, any>(
    GuestApi.updateGuest,
  );

  useResponseFormHandler({ error, response });

  useEffect(() => {
    if (response) {
      onSuccess(response?.data?.data);
    }
  }, [response, onSuccess]);

  return (
    <NewContactForm
      onSubmit={(data) => {
        doFetch({ id: data?.id, data });
      }}
      errors={error?.response?.data?.errors}
      loading={isLoading}
      guest={guest}
    />
  );
};
